const getIolazy = () => import(/* webpackChunkName: 'iolazy' */ "./iolazy")
const getNavigation = () => import(/* webpackChunkName: 'productNavigation' */ "./overlay")
const getProductDetail = () => import(/* webpackChunkName: 'productDetail' */ "./productDetail")
const getFilters = () => import(/* webpackChunkName: 'filters' */ "./filters")
const getNotifications = () => import(/* webpackChunkName: 'notifications' */ "./notifications")
const getBasket = () => import(/* webpackChunkName: 'basket' */ "./basket")
const getProduct = () => import(/* webpackChunkName: 'product' */ "./product")

const getWishlist = () => import(/* webpackChunkName: 'wishlist' */ "./wishlist")
const getCheckout = () => import(/* webpackChunkName: 'checkout' */ "./checkout")
const getDropdown = () => import(/* webpackChunkName: 'dropdown' */ "./dropdown")
const getGateway = () => import(/* webpackChunkName: 'gateway' */ "./gateway")
const getTooltip = () => import(/* webpackChunkName: 'tooltip' */ "./tooltip")
const getNotificationBar = () => import(/* webpackChunkName: 'notificationBar' */ "./notificationBar")
const getBlurhash = () => import(/* webpackChunkName: 'blurhash' */ "./blurhash")
const getSubscribe = () => import(/* webpackChunkName: 'subscribe' */ "./subscribe")
const getPhotoSwipe = () => import(/* webpackChunkName: 'photoswipe' */ "./photoswipe.js")
const getSwiper = () => import(/* webpackChunkName: 'swiperGallery' */ "./swiper")
const getLookbook = () => import(/* webpackChunkName: 'lookbook' */ "./lookbook")
const getHeaderNavigation = () => import(/* webpackChunkName: 'headerNavigation' */ "./headerNavigation")

export {
  getIolazy,
  getNavigation,
  getProductDetail,
  getFilters,
  getSwiper,
  getNotifications,
  getBasket,
  getProduct,
  getWishlist,
  getCheckout,
  getDropdown,
  getGateway,
  getTooltip,
  getNotificationBar,
  getBlurhash,
  getSubscribe,
  getPhotoSwipe,
  getLookbook,
  getHeaderNavigation,
}
